import axios from 'axios';

import urls from '../../utils/urls';
import {tokenHeader} from "../../utils/headers";
import {ajaxHandler} from '../../utils/errors';
import {
    SELECTED_STATION,
    RECEIVED_NOTES,
    SELECTED_NOTES,
    SHOW_NEW_NOTE,
    EDIT_NOTE,
    CATEGORIES_FETCHED,
    LAST_VISIT_INFO,
    FETCHING_DATA,
    CHECK_IN,
    CLEAR_STATION_SELECTION,
    USER_SELECTED_AREA,
    USER_SELECTED_ZONE,
    USER_FILTERED_AREA,
    USER_FILTERED_STATION,
    USER_FILTERED_ZONE,
    CLEAR_AREA_SELECTION,
    CLEAR_ZONE_SELECTION, USER_SELECTED_STATION
} from './../types';


export function fetchCategories(id) {
    return (dispatch) => {
        const notes_url = `${urls.API_ROOT}/api/v1/station-note-categories/`;
        axios
            .get(notes_url, tokenHeader())
            .then((response) => {
                dispatch(saveCategories(response.data));
            })
            .catch(ajaxHandler);
    }
}

export function saveCategories(payload) {
    return {
        type: CATEGORIES_FETCHED,
        payload: payload
    };
}

export function fetchNotes(station, area, zone) {
    return (dispatch) => {
        let notes_url = `${urls.API_ROOT}/api/v1/station-notes/?is_done=false`;
        if(station){
            notes_url = notes_url.concat(`&station=${station}`);
        }
        if(area){
            notes_url = notes_url.concat(`&station__zone__area=${area}`);
        }
        if(zone){
            notes_url = notes_url.concat(`&station__zone=${zone}`);
        }

        axios
            .get(notes_url, tokenHeader())
            .then((response) => {
                dispatch(saveNotes(response.data));
            })
            .catch(ajaxHandler);
    }
}


export function selectStation(id) {
    return {
        type: USER_SELECTED_STATION,
        payload: id
    };
}

export function selectArea(id) {
    return {
        type: USER_SELECTED_AREA,
        payload: id
    };
}

export function selectZone(id) {
    return {
        type: USER_SELECTED_ZONE,
        payload: id
    };
}

export function filterStation(id) {
    return {
        type: USER_FILTERED_STATION,
        payload: id
    };
}

export function filterArea(id) {
    return {
        type: USER_FILTERED_AREA,
        payload: id
    };
}

export function filterZone(id) {
    return {
        type: USER_FILTERED_ZONE,
        payload: id
    };
}

export function clearStationSelection() {
    return {
        type: CLEAR_STATION_SELECTION
    };
}

export function clearZoneSelection() {
    return {
        type: CLEAR_ZONE_SELECTION
    };
}

export function clearAreaSelection() {
    return {
        type: CLEAR_AREA_SELECTION
    };
}

export function saveNotes(payload) {
    return {
        type: RECEIVED_NOTES,
        payload: payload
    };
}

export function selectedNotes(ids) {
    return {
        type: SELECTED_NOTES,
        payload: ids
    };
}

export function addNewNote() {
    return {
        type: SHOW_NEW_NOTE,
        payload: true
    };
}

export function newNoteAdded() {
    return {
        type: SHOW_NEW_NOTE,
        payload: false
    };
}

export function editNote(note) {
    return {
        type: EDIT_NOTE,
        payload: note
    };
}

export function getVisitsInfo(id) {
    return (dispatch) => {
        const visits_url = `${urls.API_ROOT}/api/v1/station-check-ins/?station=${id}`;
        axios
            .get(visits_url, tokenHeader())
            .then((response) => {
                dispatch(saveLastVisitInfo(response.data[0]));
            })
            .catch(ajaxHandler);
    }
}

export function saveLastVisitInfo(payload){
    return {
        type: LAST_VISIT_INFO,
        payload: payload
    };
}

export function fetchingData(){
    return {
        type: FETCHING_DATA,
        payload: true
    };
}

export function checkInStation(payload){
    return {
        type: CHECK_IN,
        payload: payload
    };
}




// WEBPACK FOOTER //
// ./src/actions/visits_actions/index.js